import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import testid from '../../../services/testid-service';

import style from './modal-footer.less';

const ModalFooter = ({ className = '', children }) => {
  return (
    <div {...testid('modal-footer')} className={classNames(style['modal-footer'], className)}>
      {children}
    </div>
  );
};

ModalFooter.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default ModalFooter;
